import { render, staticRenderFns } from "./MicTest.vue?vue&type=template&id=6f80e989&scoped=true"
import script from "./MicTest.vue?vue&type=script&lang=ts"
export * from "./MicTest.vue?vue&type=script&lang=ts"
import style0 from "./MicTest.vue?vue&type=style&index=0&id=6f80e989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80e989",
  null
  
)

export default component.exports